export const FOUNDING_MEMBER_DEADLINE = "2026-04-25T00:00:00";
